import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'biz-oauth-callback',
  template: '<h1>Ok!  {{url}}</h1>'
})
export class OauthCallbackComponent implements OnInit {

  param;
  order: string;
  url: string;

  constructor(private _route: ActivatedRoute) { }
  ngOnInit() {
    this._route.queryParams
      .subscribe(params => {      
        if (params.state) {
          let urlRedirect = params.state;          
          var paramList = [];
          for (var pKey in params) {
            paramList.push({ name: pKey, value: params[pKey] });
          }
          let urlParam = paramList.filter(f => f.name != "state").map(m => m.name + "=" + m.value).reduce(function (a, b) { return (a + "&" + b) });
          this.url = urlRedirect + "?" + urlParam;       
          window.open(this.url, "_self");
        } else {
            window.close();
        }
      }
      );
  }
}
